import { type FC } from "react";

import { Card, Control, Label, Radio, RadioGroup } from "@snapchat/snap-design-system";

import { HttpRequestMethod, type RemoteApiHttpEndpoint } from "../../../../gql-generated/types";

import { ParameterContainer, cardStyle, controlStyle, inputStyle, subtitle } from "./endpoint.styles";
import { makeEndpointPrevew } from "./makeEndpointPreview";

interface EndpointDetailsProps {
    title: string;
    endpoint: RemoteApiHttpEndpoint;
    host?: string;
}
// TODO(LOOK-160933): - move text to messages
export const EndpointDetails: FC<EndpointDetailsProps> = ({ endpoint, host, title }) => {
    return (
        <Card title={title} collapsible className={cardStyle} collapsedByDefault>
            <Control
                className={controlStyle}
                label="Reference ID"
                tooltip="Unique ID for the API callers to identify this endpoint in Lens Studio."
            >
                {endpoint.refId}
            </Control>
            <Control className={controlStyle} label="Path" tooltip="Path of the URL (without leading slash).">
                {endpoint.path}
            </Control>

            <Control className={controlStyle} label="Method">
                <RadioGroup horizontal={true} value={endpoint.methods[0]} disabled={true}>
                    <Radio label="GET" value={HttpRequestMethod.Get} />
                    <Radio label="POST" value={HttpRequestMethod.Post} />
                    <Radio label="DELETE" value={HttpRequestMethod.Delete} />
                </RadioGroup>
            </Control>

            <Control className={controlStyle} label="Preview">
                {makeEndpointPrevew(endpoint, host)}
            </Control>

            <Label className={subtitle}> Parameters </Label>
            {endpoint.parameters.map((param, index) => {
                return (
                    <ParameterContainer key={index}>
                        <Control
                            className={controlStyle}
                            label="Parameter Name"
                            tooltip="Name of the parameter that will be used to fill the API request."
                        >
                            {param.name}
                        </Control>

                        <Control
                            className={inputStyle}
                            label="Parameter Location"
                            tooltip="How the parameter is passed to the service (query string, header, or URL path)."
                        >
                            {param.location}
                        </Control>

                        <Control className={controlStyle} label="Required">
                            {/* values is iverted, since we have param.optional field on the spec, but show Required to the user */}
                            <RadioGroup horizontal={true} value={!param.optional} disabled={true}>
                                <Radio label="Yes" value={true} />
                                <Radio label="No" value={false} />
                            </RadioGroup>
                        </Control>

                        <Control className={controlStyle} label="Constant">
                            <RadioGroup horizontal={true} value={param.constant} disabled={true}>
                                <Radio label="Yes" value={true} />
                                <Radio label="No" value={false} />
                            </RadioGroup>
                        </Control>
                    </ParameterContainer>
                );
            })}
        </Card>
    );
};
